import React from 'react';
import {HashRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import SoundsGrid from './pages/SoundsGrid';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #b5c9c8 0%, #ccacb2 50%, #f2bdb1 100%)'}}>
        <Routes>
          <Route path="/" element={<Navigate to="/sounds" replace />} />
          <Route path="/sounds" element={<SoundsGrid />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;